import { createEvent, createStore } from 'effector'

export const enterCreditCardNumber = createEvent<{ value: string }>()
export const enterCreditCardMonth = createEvent<{ value: string }>()
export const enterCreditCardYear = createEvent<{ value: string }>()
export const enterCreditCardCvv = createEvent<{ value: string }>()

export const $creditCardNumber = createStore<string>('') //
  .on(enterCreditCardNumber, (_, { value }) => value)

export const $creditCardMonth = createStore<string>('') //
  .on(enterCreditCardMonth, (_, { value }) => value)

export const $creditCardYear = createStore<string>('') //
  .on(enterCreditCardYear, (_, { value }) => value)

export const $creditCardCvv = createStore<string>('') //
  .on(enterCreditCardCvv, (_, { value }) => value)

//
// guess credit card type
//

const types = {
  'Visa': /^4/,
  'MasterCard': /^(5[1-5]|222[1-9]|22[3-9]|2[3-6]|27[0-1]|2720)\d*$/,
  'American Express': /^3[47]/,
}

export const $creditCardType = createStore<string>('') //
  .on($creditCardNumber, (_, number) => {
    for (const [type, matcher] of Object.entries(types)) {
      if (number.match(matcher)) {
        return type
      }
    }
    return ''
  })
